import React from 'react';

import { TemplateList } from '@weezevent/templar';
import { Card, ContentCard } from '@weezevent/nacre';

export const TemplatesList = ({ organizationId }) => {
    return (
        <Card>
            <ContentCard>
                <TemplateList organizationId={organizationId} />
            </ContentCard>
        </Card>
    );
};
